export default function isNetworkError(error) {
  if (error.message.includes('Network error')) { return true; }

  if (error.networkError) {
    return error.networkError.statusCode === 500 || error.networkError.statusCode === 400;
  }

  return false;
}
